/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'help': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75 30c-24.898 0-45 20.102-45 45s20.102 45 45 45 45-20.102 45-45-20.102-45-45-45zm38.602 34.602h-10.5C100 56.302 93.302 49.704 85 46.704V36.306c13.898 3.594 24.898 14.395 28.602 28.297v-.001zM75 100c-13.801 0-25-11.199-25-25s11.199-25 25-25 25 11.199 25 25-11.199 25-25 25zM65 36.301v10.398c-8.398 3-15.102 9.5-18.102 17.898h-10.5C40.101 50.699 51.101 39.898 65 36.3v.001zM36.199 84.602h10.398c2.898 8.7 9.8 15.602 18.398 18.699v10.398C50.8 110.101 39.698 98.801 36.198 84.601l.001.001zM85 113.7v-10.398c8.7-3.102 15.5-10 18.398-18.699h10.398c-3.496 14.199-14.598 25.5-28.797 29.098L85 113.7z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
